import { catchError } from 'rxjs/operators';
import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, of} from 'rxjs';
import { AuthenticationService } from '../_services';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  session: string;
  constructor(private authenticationService: AuthenticationService, private router: Router
) {
}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      });
    }
    
    // return next.handle(request).pipe(
    //   catchError((err, caught) => {
    //     if (err.status === 401) {
    //       this.handleAuthError();
    //       return of(err);
    //     }
    //     if (err.status === 500){
    //       return of(err);
    //     }

    //      if (err.error instanceof Error) {
    //       console.log('An error occurred:', err.error.message);
    //      }
    //     throw err;
    //   })
    // );

    return next.handle(request).pipe(
            catchError(
              (err, caught) => {
                if (err.status === 401) {
                  this.handleAuthError();
                  return of(err);
                }
                throw err;
              }
            )
          );
          
  }

  handleAuthError(){
    localStorage.removeItem('currentUser');
    this.router.navigateByUrl('/login');
    this.router.navigate(["/login"]);
    window.location.reload();
  }

}